import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;
const commonAPI = {
	contactUs: (form: any) => {
		const data = { ...form };
		return axios.post(`${apiUrl}/contact-us`, data)
			.then(response => response.data);
	},
	fileAClaim: (form: any) => {
		const data = { ...form };
		return axios.post(`${apiUrl}/file-a-claim`, data)
			.then(response => response.data);
	}
};

export default commonAPI;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/commonAPI.ts